/*
  Categorie, articoli e pagine correlati nella pagina di ricerca.

  Il search object lato server non conosce le collezioni e fuori da un blocco
  paginate restituisce al massimo dieci risultati: i gruppi sotto la griglia
  arrivano quindi dalla Predictive Search API, che indicizza anche le
  collezioni. Il markup sta in sections/search-related.liquid, qui c'e' solo
  l'orchestrazione.

  Senza JavaScript il contenitore resta vuoto e nascosto: la pagina di ricerca
  continua a funzionare con la sua griglia di prodotti.
*/
(() => {
  const RISULTATI_PER_TIPO = 8;

  const contenitore = document.querySelector('[data-ricerca-correlati]');

  if (!contenitore) return;

  const termine = (contenitore.dataset.termini || '').trim();

  if (!termine) return;

  const base =
    window.routes && window.routes.predictive_search_url
      ? window.routes.predictive_search_url
      : '/search/suggest';

  const parametri = new URLSearchParams({
    q: termine,
    'resources[type]': 'collection,article,page',
    'resources[limit]': RISULTATI_PER_TIPO,
    'resources[limit_scope]': 'each',
    section_id: 'search-related',
  });

  // I conteggi in cima alla pagina: quelli dei prodotti li scrive Liquid, qui
  // si aggiungono le aree che esistono solo in questo blocco. Il numero e'
  // quello delle schede montate, non un totale di catalogo.
  const GRUPPI = [
    { id: 'ricerca-categorie', selettore: '.search-related__categorie li', uno: 'categoria', molti: 'categorie' },
    { id: 'ricerca-articoli', selettore: '.search-related__articoli .card', uno: 'articolo', molti: 'articoli' },
    { id: 'ricerca-pagine', selettore: '.search-related__pagine li', uno: 'pagina', molti: 'pagine' },
  ];

  const aggiornaConteggi = () => {
    const elenco = document.querySelector('[data-conteggi-ricerca]');

    if (!elenco) return;

    GRUPPI.forEach((gruppo) => {
      const quanti = contenitore.querySelectorAll(gruppo.selettore).length;

      if (!quanti) return;

      const voce = document.createElement('li');
      const link = document.createElement('a');
      const numero = document.createElement('strong');

      link.className = 'search-results__conteggio p';
      link.href = `#${gruppo.id}`;
      numero.textContent = quanti;
      link.append(numero, ` ${quanti === 1 ? gruppo.uno : gruppo.molti}`);
      voce.appendChild(link);
      elenco.appendChild(voce);
    });
  };

  fetch(`${base}?${parametri}`)
    .then((risposta) => (risposta.ok ? risposta.text() : Promise.reject(risposta.status)))
    .then((html) => {
      contenitore.innerHTML = html;

      // la section renderizzata e' vuota quando nessuna collezione, articolo o
      // pagina corrisponde: in quel caso il blocco non deve comparire
      if (!contenitore.textContent.trim()) return;

      contenitore.hidden = false;
      aggiornaConteggi();
    })
    .catch(() => {
      // errore di rete: la griglia dei prodotti resta comunque completa
    });
})();
